import axios from "axios";
import env from "../config/env";
import { setItem } from "../localStorageUtil";
import { useAuthExpirationModal } from "../../context/AuthExpiration";
import { useEffect, useState } from "react";

const axiosInstance = axios.create({
  baseURL: env.BASE_URL, // Your API base URL
});

export const axiosPublicInstance = axios.create({
  baseURL: env.BASE_URL,
});

export const AxiosInterceptor = ({ children }) => {
  const [isReady, setIsReady] = useState(false); // this state will determin whether axios instance is ready or not
  const { setModalOpen } = useAuthExpirationModal();
  useEffect(() => {
    const resInterceptor = (response) => {
      const { accessToken, refreshToken } = response?.data;
      if (accessToken) setItem("accessToken", accessToken);
      if (refreshToken) setItem("refreshToken", refreshToken);
      return response;
    };

    const errInterceptor = (error) => {
      const { status } = error;
      if (status === 401) {
        setModalOpen(true);
      }

      return Promise.reject(error);
    };

    const interceptor = axiosInstance.interceptors.response.use(
      resInterceptor,
      errInterceptor
    );
    setIsReady(true);
    return () => axiosInstance.interceptors.response.eject(interceptor);
  }, []);
  return isReady ? children : null;
};

axiosInstance.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem("accessToken");
    const refreshToken = localStorage.getItem("refreshToken");
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
      config.headers.refreshToken = `Bearer ${refreshToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// axiosInstance.interceptors.response.use(
//   (response) => {
//     const { accessToken, refreshToken } = response?.data;
//     if (accessToken) setItem("accessToken", accessToken);
//     if (refreshToken) setItem("refreshToken", refreshToken);
//     return response;
//   },
//   (error) => {
//
//     const { status } = error;
//     if (status === 401 || status === 403) {
//       setModalOpen(true);
//     }

//     return Promise.reject(error);
//   }
// );

// Public instance that doesn't use any tokens

export default axiosInstance;
